import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { TechnicalDisclaimer } from "../components/site/TechnicalDisclaimer";
import { CTASection } from "../components/site/CTASection";
import { SIL_ARTICLES, SIL_SECTIONS } from "../data/technical";

export default function SiliconeCentre() {
  return (
    <div>
      <PageHero
        variant="dark"
        label="Silicone Knowledge Centre"
        title="Understanding Silicones"
        intro="Understand HCR, LSR and RTV systems, silicone compounding principles, reinforcing fillers, cure systems and formulation architecture."
        crumbs={[{ label: "Technical Hub", to: "/technical-hub" }, { label: "Silicones" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          {SIL_SECTIONS.map((section) => {
            const items = SIL_ARTICLES.filter((a) => a.section === section);
            if (!items.length) return null;
            return (
              <div key={section} className="mb-12">
                <SectionLabel>{section}</SectionLabel>
                <div className="grid gap-px border border-brand-line bg-brand-line md:grid-cols-2 lg:grid-cols-3">
                  {items.map((a) => (
                    <Link
                      key={a.slug}
                      to={`/technical-hub/silicones/${a.slug}`}
                      data-testid={`sil-article-${a.slug}`}
                      className="group flex flex-col bg-white p-6 transition-colors hover:bg-brand-blue/[0.03]"
                    >
                      <h3 className="font-heading text-base font-bold leading-snug text-brand-ink group-hover:text-brand-blue">
                        {a.title}
                      </h3>
                      <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-muted">{a.summary}</p>
                      <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-brand-blue">
                        Read <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}

          <div className="mb-10 border border-brand-line bg-brand-bg p-8">
            <SectionLabel>Formulation philosophy</SectionLabel>
            <p className="max-w-3xl text-[16px] leading-relaxed text-brand-ink/85">
              MATRIVON teaches how to think about formulations rather than publishing uncontrolled
              commercial recipes. Understanding the architecture — gum, reinforcing filler, process
              aid, functional additives, pigment, curing system and processing optimisation — makes
              the content genuinely valuable without exposing proprietary formulations.
            </p>
          </div>

          <div className="mb-10 flex flex-wrap items-center justify-between gap-4 border border-brand-line bg-white p-8">
            <div>
              <h3 className="font-heading text-lg font-bold text-brand-ink">Silicone Resource Library</h3>
              <p className="mt-1 text-sm text-brand-muted">Curated manufacturer and technical resources.</p>
            </div>
            <Link to="/technical-hub/resources" className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue hover:gap-2.5">
              Browse resources <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <TechnicalDisclaimer />
        </div>
      </section>

      <CTASection primary={{ to: "/advisory/industrial-advisory", label: "Explore Industrial Advisory" }} secondary={{ to: "/contact", label: "Contact MATRIVON" }} />
    </div>
  );
}
